import { store, getContext, getElement } from '@wordpress/interactivity';

store( 'brandy/flip-card', {
	actions: {
		toggleFlip() {
			const ctx = getContext();
			ctx.isFlipped = ! ctx.isFlipped;
		},
		flipOn() {
			const ctx = getContext();
			ctx.isFlipped = true;
		},
		flipOff() {
			const ctx = getContext();
			ctx.isFlipped = false;
		},
		handleKeydown( event ) {
			if ( event.key === 'Enter' || event.key === ' ' ) {
				event.preventDefault();
				const ctx = getContext();
				ctx.isFlipped = ! ctx.isFlipped;
			}
		},
	},
	callbacks: {
		initHeight() {
			const ctx = getContext();
			if ( ctx.heightMode !== 'auto' ) {
				return;
			}

			const { ref } = getElement();
			const front = ref.querySelector( '.brandy-flip-card-front' );
			const back = ref.querySelector( '.brandy-flip-card-back' );
			if ( ! front || ! back ) {
				return;
			}

			const updateHeight = () => {
				const maxHeight = Math.max(
					front.scrollHeight,
					back.scrollHeight
				);
				ref.style.setProperty( '--flip-height', maxHeight + 'px' );
			};

			updateHeight();

			// Re-measure when images load
			ref.querySelectorAll( 'img' ).forEach( ( img ) => {
				if ( ! img.complete ) {
					img.addEventListener( 'load', updateHeight, {
						once: true,
					} );
				}
			} );

			// Re-measure on content size changes
			const observer = new ResizeObserver( updateHeight );
			observer.observe( front );
			observer.observe( back );
		},
	},
} );
